var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulltArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 12,
    viewBox: "0 0 96 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6L48 6",
    stroke: "#17B26A",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99984 4.66666C4.73622 4.66666 5.33317 5.26362 5.33317 5.99999C5.33317 6.73637 4.73622 7.33333 3.99984 7.33333C3.26346 7.33333 2.6665 6.73637 2.6665 5.99999C2.6665 5.26362 3.26346 4.66666 3.99984 4.66666Z",
    fill: "#17B26A",
    stroke: "#17B26A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 6L88 6",
    stroke: "#17B26A",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_197_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9998 4.66666C92.7362 4.66666 93.3332 5.26362 93.3332 5.99999C93.3332 6.73637 92.7362 7.33333 91.9998 7.33333C91.2635 7.33333 90.6665 6.73637 90.6665 5.99999C90.6665 5.26362 91.2635 4.66666 91.9998 4.66666Z",
    fill: "#17B26A",
    stroke: "#17B26A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_197_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(0 -1 1 0 88 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulltArrow);
export default __webpack_public_path__ + "static/media/bullt_arrow.a0af17849aafedb93d0d08bd35a8fcc8.svg";
export { ForwardRef as ReactComponent };